import {
  getDeferralType,
  getServiceEligibility,
  getFirmName,
  getFundList,
  getTpaFirmName,
  getSafeHarborDiscretionaryMatchContType,
} from './pardotHelperUtilities';
import API from '../../api';
import { getSafeHarbor } from '../Salesforce/salesforceHelperUtilities';

const api = API.create();

export const pardotHelper = ({
  formData,
  stageFlag,
  link,
  advisorCvStatus,
  advisorIndex = 0,
  role,
  tpaParadigmPackager = [],
}) => {
  const {
    planDesign: {
      advisors,
      tpas,
      questions: {
        sponsorEmail: { value: sponsorEmail },
        sponsorFirstName: { value: sponsorFirstName },
        sponsorLastName: { value: sponsorLastName },
        employerStateCode: { value: employerStateCode },
        sponsorTitle: { value: sponsorTitle },
        companyPhone: { valueFormatted: companyPhone },
        companyName: { value: company },
        averageSalary,
        numberOfEmployees: { value: employees },
        employerContributionMatch: { value: employerContributionMatch },
        safeHarbor: { value: safeHarbor },
        autoDeferralType: { value: autoDeferralType },
        serviceEligibility: { value: serviceEligibility },
        stretchSafeHarbor: { valueFormatted: stretchSafeHarbor },
        employerPaidParticipantFees: { value: employerPaidParticipantFees },
        employerMatch: { valueFormatted: employerMatch },
        firmNameFreeForm,
        advisorFirmBroker: { valueFormatted: parentBroker },
        planEffectiveDate: { value: planEffectiveDate },
        currentPlan: { value: currentPlan },
        tpaFirmName,
        tpaFirmNameUnlisted: { value: tpaFirmNameUnlisted },
        investmentLineup,
        planUsingSafeHarbor,
        whichSafeHarbor,
        hasTpa,
        hasFp,
        sponsorEmployerIdentificationNumber,
      },
    },
  } = formData;
  const {
    minimumAutoDeferralPercentage,
    minServiceReqEligibility,
    planEffectiveDate: { value: tpaPlanEffectiveDate } = {
      value: '',
      valueFormatted: '',
    },
  } = tpaParadigmPackager;
  const {
    advisorEmail: { value: advisorEmail },
    advisorFirstName: { value: advisorFirstName },
    advisorLastName: { value: advisorLastName },
    advisorPhone: { value: advisorPhone },
    advisorStateCode: { value: advisorStateCode },
    advisorNpn: { value: advisorNpn },
    firmName: {
      value: { value: brokerDealer },
    },
    advisorZipCode: { value: zip },
  } = advisors[advisorIndex].questions;
  const {
    crd: { value: crd },
    brokerType,
  } = advisors[advisorIndex].advisorCredentialVerification;
  const {
    tpaFirstName: { value: tpaFirstName },
    tpaLastName: { value: tpaLastName },
    tpaEmail: { value: tpaEmail },
    tpaPhone: { value: tpaPhone },
  } = tpas[0].questions;

  const planPardotData = {
    company,
    stage_flag: stageFlag,
    estimated_pay: averageSalary.value,
    employees,
    Employer_Identification_Number_EIN:
      sponsorEmployerIdentificationNumber.value,
    advisor_npn: advisorNpn,
    Broker_CRD: brokerType !== 'insuranceAgent' ? crd : '',
    tpa_email: hasTpa.value ? tpaEmail : '',
    tpa_firmName: hasTpa.value
      ? getTpaFirmName(tpaFirmName.value, tpaFirmNameUnlisted)
      : '',
    auto_enrollment_deferral_escalation_rate: getDeferralType(
      formData.planDesign,
      minimumAutoDeferralPercentage,
    ),
    auto_enroll_employee_contribution_increase:
      autoDeferralType === 'ESCALATING'
        ? '1% each year, up to 10%'
        : 'Employee Decides',
    plan_eligibility: hasTpa.value
      ? getServiceEligibility(minServiceReqEligibility?.value)
      : getServiceEligibility(serviceEligibility),
    participant_fee_payment:
      employerPaidParticipantFees === 'true' ? 'Employer' : 'Employee',
    plan_id: link,
    advisor_broker_dealer: brokerDealer || '',
    parent_broker_dealer: parentBroker,
    credentialed_advisor: advisorCvStatus === 'PASS',
    plan_effective_date: planEffectiveDate || tpaPlanEffectiveDate,
    firm: getFirmName(
      role,
      hasFp,
      hasTpa,
      firmNameFreeForm.value,
      tpaFirmName.value,
      tpaFirmNameUnlisted,
    ),
  };
  const pardotSafeHarborDiscretionaryMatchContType =
    getSafeHarborDiscretionaryMatchContType(
      safeHarbor,
      planUsingSafeHarbor,
      employerMatch,
      whichSafeHarbor,
      stretchSafeHarbor,
      hasTpa,
      employerContributionMatch,
    );

  if (investmentLineup.dirty) {
    planPardotData.fund_list = getFundList(investmentLineup);
  } else {
    planPardotData.fund_list = 'Simply Fund Lineup 1';
  }

  if (safeHarbor === 'nonSafeHarbor' || planUsingSafeHarbor.value === 'no') {
    planPardotData.discretionary_match_formula =
      employerMatch !== '' ? employerMatch : 'None';
    planPardotData.safe_harbor = 'None';
  } else if (
    safeHarbor === 'safeHarbor' ||
    planUsingSafeHarbor.value === 'yes'
  ) {
    if (hasTpa.value) {
      planPardotData.safe_harbor = getSafeHarbor(whichSafeHarbor.value);
      planPardotData.discretionary_match_formula = 'None';
    } else {
      planPardotData.safe_harbor =
        stretchSafeHarbor === 'Stretch your match'
          ? 'Basic Match (100% of 1st 3%+50% of next 2%)'
          : '4% Enhanced Match';
      planPardotData.discretionary_match_formula = '';
    }
  }

  const advisorPardotData = {
    ...planPardotData,
    ...pardotSafeHarborDiscretionaryMatchContType,
    email: advisorEmail,
    first_name: advisorFirstName,
    last_name: advisorLastName,
    state: advisorStateCode,
    lead_type: role,
    phone: advisorPhone,
    zip,
  };

  const tpaPardotData = {
    ...planPardotData,
    ...pardotSafeHarborDiscretionaryMatchContType,
    email: tpaEmail,
    first_name: tpaFirstName,
    last_name: tpaLastName,
    lead_type: role,
    phone: tpaPhone,
  };

  const employerPardotData = {
    ...planPardotData,
    ...pardotSafeHarborDiscretionaryMatchContType,
    email: sponsorEmail,
    first_name: sponsorFirstName,
    last_name: sponsorLastName,
    state: employerStateCode,
    lead_type: role,
    lead_source: 'Simply Retirement',
    lead_source_detail: role === 'Psivet' ? role : '',
    current_plan: currentPlan,
    phone: companyPhone,
    financial_professional_first_name: advisorFirstName,
    financial_professional_last_name: advisorLastName,
    financial_professional_email_address: advisorEmail,
    secondary_financial_professional_emails: formData.planDesign.advisors
      .slice(1)
      .map((secondaryAdvisor) => secondaryAdvisor.questions.advisorEmail.value)
      .join(','),
    secondary_financial_professional_names: formData.planDesign.advisors
      .slice(1)
      .map(
        (secondaryAdvisor) =>
          `${secondaryAdvisor.questions.advisorFirstName.value} ${secondaryAdvisor.questions.advisorLastName.value}`,
      )
      .join(','),
    advisor_state: advisorStateCode,
    advisor_phone: advisorPhone,
    job_title: sponsorTitle,
  };

  if (role === 'advisor') {
    return advisorPardotData;
  }
  if (role === 'tpa') {
    return tpaPardotData;
  }

  return employerPardotData;
};

export const createProspect = async (
  formData,
  authenticityToken,
  stageFlag,
  link,
  advisorCvStatuses,
  tpaParadigmPackager = [],
) => {
  const employerPardotData = pardotHelper({
    formData,
    stageFlag,
    link,
    advisorCvStatus: advisorCvStatuses.every((status) => status === 'PASS')
      ? 'PASS'
      : 'FAIL',
    advisorIndex: 0,
    role: 'employer',
    tpaParadigmPackager,
  });
  const tpaPardotData = pardotHelper({
    formData,
    stageFlag,
    link,
    role: 'tpa',
    tpaParadigmPackager,
  });

  if (employerPardotData.email !== '') {
    await api.createProspect({
      ...employerPardotData,
      authenticity_token: authenticityToken,
    });
  }

  if (tpaPardotData.email !== '') {
    await api.createProspect({
      ...tpaPardotData,
      authenticity_token: authenticityToken,
    });
  }

  formData.planDesign.advisors.map(async (_advisor, index) => {
    const advisorProspect = pardotHelper({
      formData,
      stageFlag,
      link,
      advisorCvStatus: advisorCvStatuses[index],
      advisorIndex: index,
      role: 'advisor',
      tpaParadigmPackager,
    });

    if (advisorProspect.email !== '') {
      await api.createProspect({
        ...advisorProspect,
        authenticity_token: authenticityToken,
      });
    }
  });
};
